import Api from './Api';

const abortKey = 'FibuJahresabschlussApi';
const endpoint = '/fibu/jahresabschluss';

export default {
    abort() {
        Api.abort(abortKey);
    },
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint,
            usedParams,
            true,
            false,
            abortKey
        )
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    getYears() {
        return Api.fetchData(endpoint + "/years");
    }
};